import { getTrackBackground } from 'react-range';
import theme from '@styles/theme';

export default {
  filterContainer: (dropdown: boolean) => ({
    width: '100%',
    mb: dropdown ? '' : '44px',
    touchAction: ['none', 'none', 'auto'],
  }),
  inputContainer: {
    display: 'flex',
  },
  numberInput: (hasError: boolean) => ({
    height: '32px',
    textAlign: 'center',
    maxWidth: '100px',
    minWidth: '85px',
    fontSize: theme.fontSizes.smallText,
    border: `1px solid ${hasError ? theme.rawColors.accent700 : theme.rawColors.darkGrey300} `,
    color: hasError ? theme.rawColors.accent700 : theme.rawColors.darkGrey700,
    mt: '4px',
  }),
  dash: {
    position: 'relative',
    display: 'flex',
    minWidth: '40px',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,

    '&:after': {
      content: '""',
      position: 'absolute',
      width: '20px',
      height: '1px',
      background: theme.rawColors.neutralBlack,
    },
  },
  unit: {
    fontSize: '12px',
    display: 'inline-flex',
    alignItems: 'center',
    mx: '8px',
    color: theme.rawColors.darkGrey500,
  },
  rangeError: {
    color: theme.rawColors.accent700,
  },
  sliderWrapper: {
    px: ['16px', '16px', 0],
    touchAction: 'none',
    overscrollBehavior: 'contain',
  },
  trackContainer: {
    position: 'relative',
    height: ['56px', '56px', '24px'],
    display: 'flex',
    width: '100%',
    mt: '20px',
    mb: ['32px', '32px', '40px'],
    touchAction: 'none',
    WebkitTouchCallout: 'none',
    userSelect: 'none',
  },
  track: (value, defaultValue) => ({
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    transform: 'translateY(-50%)',
    height: '2px',
    width: '100%',
    borderRadius: '4px',
    pointerEvents: 'none',
    background: getTrackBackground({
      values: value,
      colors: [theme.rawColors.lightGrey500, theme.rawColors.accent700, theme.rawColors.lightGrey500],
      min: defaultValue.min,
      max: defaultValue.max,
    }),
  }),
  thumb: (isDragged) => {
    const thumbColor = isDragged ? theme.rawColors.darkGrey300 : theme.rawColors.lightGrey700;

    return {
      height: ['48px', '48px', '24px'],
      width: ['48px', '48px', '24px'],
      borderRadius: '50%',
      backgroundColor: 'transparent',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      touchAction: 'none',
      cursor: isDragged ? 'grabbing' : 'grab',
      WebkitTapHighlightColor: 'transparent',
      WebkitTouchCallout: 'none',
      userSelect: 'none',
      outline: 'none',
      boxShadow: 'none',
      '&:focus': {
        outline: 'none',
        boxShadow: 'none',
      },
      '&:focus-visible': {
        outline: 'none',
        boxShadow: 'none',
      },
      '&::after': {
        content: '""',
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        backgroundColor: thumbColor,
        flexShrink: 0,
        pointerEvents: 'none',
      },
    };
  },
};
